import React, { forwardRef, PropsWithChildren } from 'react';
import { ComponentBoxProps } from './box.types';

export const Box = forwardRef((props: PropsWithChildren<ComponentBoxProps>, ref: any) => {
  const { as = 'div', children, ...rest } = props;
  return React.createElement(as, { ...rest, ref }, children);
});

export default Box;
